import { Injectable } from '@angular/core';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { INotesTemplateDTO, INotesTemplateEntityDTO } from '@modeso/types__aumico-lib-notes-be';
import { NotesTypesHelper } from '../helpers/notesTypes.helper';
import { ILegalFormAndAccountBasisCombination } from '../interfaces/ILegalFormAndAccountBasisCombination.interface';
import { INotesTemplateFormValue } from '../interfaces/INotesTemplateFormValue.interface';
import { INotesTemplatesTableData } from '../interfaces/INotesTemplatesTableData.interface';

@Injectable({
    providedIn: 'root',
})
export class NotesTemplateMapper {
    constructor(private notesTypeHelper: NotesTypesHelper) {}

    prepareNotesTemplateRequest(
        notesTemplate: INotesTemplateFormValue,
        retrievedNotesTemplate?: INotesTemplateFormValue,
    ): INotesTemplateEntityDTO {
        const notesTemplateRequest: INotesTemplateEntityDTO = {
            _id: retrievedNotesTemplate ? retrievedNotesTemplate._id : undefined,
            name: notesTemplate.name ? notesTemplate.name : retrievedNotesTemplate.name,
            accountBasis: notesTemplate.accountBasis,
            legalForm: notesTemplate.legalForm,
            notesTypes: this.getNameOfSelectNotesTypes(notesTemplate.notesTypes),
        };

        return notesTemplateRequest;
    }

    private getNameOfSelectNotesTypes(selectedNotesTypes: INameId[]): string[] {
        const notesTypes: string[] = [];

        for (const selectedNotesType of selectedNotesTypes) {
            notesTypes.push(selectedNotesType.id.toString());
        }

        return notesTypes;
    }

    prepareNotesTemplateOfUpdateMode(retrievedNotesTemplate: INotesTemplateDTO): INotesTemplateFormValue {
        const notesTemplate: INotesTemplateFormValue = {
            _id: retrievedNotesTemplate._id,
            name: retrievedNotesTemplate.name,
            accountBasis: retrievedNotesTemplate.accountBasis,
            legalForm: retrievedNotesTemplate.legalForm,
            notesTypes: this.notesTypeHelper.getIdsAndNamesOfNotesTypes(retrievedNotesTemplate.notesTypes),
            owner: retrievedNotesTemplate.owner,
        };

        return notesTemplate;
    }

    prepareNotesTemplateListData(retrievedNotesTemplates: INotesTemplateDTO[]): INotesTemplatesTableData[] {
        const notesTemplatesTableData: INotesTemplatesTableData[] = [];

        for (const notesTemplate of retrievedNotesTemplates) {
            const notesTemplateData: INotesTemplatesTableData = {
                _id: notesTemplate._id,
                name: notesTemplate.name,
                accountBasis: notesTemplate.accountBasis?.name,
                legalForm: notesTemplate.legalForm?.name,
            };

            notesTemplatesTableData.push(notesTemplateData);
        }

        return notesTemplatesTableData;
    }

    public getLegalFormAndAccountBasis(data: INotesTemplateFormValue): ILegalFormAndAccountBasisCombination {
        const legalFormAndAccountBasis: ILegalFormAndAccountBasisCombination =
            {} as ILegalFormAndAccountBasisCombination;

        if (data != null) {
            legalFormAndAccountBasis.legalForm = data.legalForm as INameId;
            legalFormAndAccountBasis.accountBasis = data.accountBasis as INameId;
        }

        return legalFormAndAccountBasis;
    }
}
